var exports = {
  "n": "x112a1f60--4b50f3--link",
  "U": "x112a1f60--4b50f3--arrow",
};

module.exports = exports;
